import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export function useCMS() {
  return useQuery({
    queryKey: ["cms"],
    queryFn: api.getCMS,
    staleTime: 1000 * 60 * 10
  });
}
